<div class="container-login">
  @if (isResumingSession) {
    <div class="auth-resume content-login" aria-live="polite" aria-busy="true">
      <div class="logo-login" title="NTT Data, Inc."></div>

      <hr class="divisor-login auth-resume-divisor" />

      <div class="auth-resume-spinner" aria-hidden="true">
        <span class="auth-resume-spinner-ring"></span>
        <span class="auth-resume-spinner-core"></span>
      </div>

      <p class="auth-resume-title">Signing you in</p>
      <p class="auth-resume-subtitle">Setting up your secure session&hellip;</p>
    </div>
  } @else {
    <div class="content-login">
    <div class="logo-login" title="NTT Data, Inc."></div>

    <hr class="divisor-login" />

    <div class="info-login">
      <strong>Pick an account</strong>
      <p>select your account for access</p>
    </div>

    <div class="avatar-login">
      <span class="avatar-img" [title]="content?.username"></span>

      <span class="avatar-info">
        <strong>{{ username ? username : 'Sign in' }}</strong>
        <small>{{ soCapture ? soCapture[0] : 'Sign in to proceed.' }}</small>
      </span>
    </div>

    <button
      class="btn btn-login"
      [class.disabled]="disableBtn"
      [disabled]="disableBtn"
      [attr.aria-busy]="disableBtn"
      type="button"
      (click)="login()"
    >
      Login
    </button>

    <hr class="divisor-login" />

    <span class="support-login">
      <i class="support-img"></i> Can't access?
      <a
        href="mailto:AM.US.OM.BusinessSolutions@global.ntt?Subject=Help!&Body=I can't log in to the platform. %0D%0AWould you help me?"
        title="Click to send mail"
        (click)="disableBtnTime()"
        >Click here</a
      >
      to contact the support
    </span>
    </div>
  }
</div>
